export const defaultState = {};

export default function delegates(state = defaultState, action)
{
    switch (action) {
        case 'ADD_DELEGATE':
            console.log('Delegate Added');
            break;
        default:
            return state;
    }
}
